import {
  LOGIN_REQUEST,
  LOGOUT,
  REGISTER_REQUEST,
  GET_PROFILE,
  SET_PROFILE_PROP,
  UPDATE_PROFILE,
  RESTORE_AUTH,
  SET_MODAL,
  RESET_PASSWORD,
  SET_PROTECTED_REFERRER,
  VALIDATE_EMAIL,
  SEND_REFER,
  SEND_VOUCHER_CODE,
  GET_VOUCHERS,
  CHECKOUT_DISCOUNT_VOUCHERS,
  REMOVE_VOUCHER,
  CLEAR_GUEST_FORM,
  CLEAR_REGISTER_FORM,
  REMOVE_PROFILE,
  UPDATE_PROFILE_IMAGE,
  BUY_REWARD,
  CHECKOUT_MULTI_BASKET_DISCOUNT,
  GET_GIFT_CARDS,
  CHECK_VOUCHER_DISCOUNT,
  CHECKOUT_TAX_MULTI_BASKET_DISCOUNT,
  CHECKOUT_TAX_DISCOUNT_VOUCHERS,
  SEND_GIFT_CARD_CODE,
  DELETE_NOTIFICATION,
  READ_NOTIFICATION,
  SET_NOTIFICATIONS,
  GET_NOTIFICATIONS,
  REMOVE_GIFT_CARD,
} from './constants';
import {
  SET_ORDERS_PROP,
  GET_ORDER_HISTORY,
  SET_COMMON_MODAL,
  /*INIT_FIREBASE_DATABASE,*/ ADD_DELIVERY_ADDRESS,
  ADD_PICKUP_POINT,
  SET_COMMON_PROP,
  SET_NAVCONFIG,
} from '../constants';
import { loading } from '../common/sagas';
import { take, call, put, select, cancel, spawn } from 'redux-saga/effects';
import api, { isAuthorizationTokenSet } from '../../lib/api';
import { forwardTo, getDefaultRoute, isDefined, validateProfileData } from '../../lib/utils';
import asyncStorage from '../../lib/asyncStorage';
import { saveFcmToken, translateSaga, firebaseDatabase } from '../common/sagas';
import { getPaymentCards, showToast, storeDeliveryAddress, storePickUpPoint } from '../actions';
import Basket from '../../lib/basket';
import { getConfig, updateConfig } from '../../appConfig';
import delay from '@redux-saga/delay-p';
import moment, { applayLocale } from '../../lib/moment';
import { errorHandlerSaga } from '../sagas';
import { Capacitor } from '@capacitor/core';
import { initRouter } from '../../navConfig';

/**
 * Effect to handle authorization
 * @param { string } username The username of the user
 * @param { string } password The password of the user
 * @param { object } options Options
 * @param { boolean } options.isRegistering Is this a register request?
 */
export const authorize = function* (data) {
  const authStore = yield select((state) => state.profile.auth);
  if (authStore.loggedIn) {
    return authStore;
  }
  let returnValue = null;
  if (data.isRegistering) {
    data.isRegistering = undefined;
    const registerData = yield call(api.register, data);
    returnValue = registerData;
  } else {
    data.isRegistering = undefined;
    const { username, password, socialAuth } = data;
    const loginData = yield call(api.login, username, password, socialAuth);
    returnValue = loginData;
  }

  return returnValue;
};

/* Login saga */
export const loginFlow = function* () {
  while (true) {
    const { username, password, referrer, referrerState, fromBillPay, socialAuth, promo_code, paymentType, fromLoyaltyPage, createOrder } = yield take(LOGIN_REQUEST);


    const store = yield select();
    const type = Basket.getOrderType();
    let tryRegister = false;
    yield call(loading, function* () {
      const response = yield call(authorize, { username, password, isRegistering: false, socialAuth });
      if (response?.data && response.data.try_register) {
        tryRegister = true;
        forwardTo('/register', { saveRegisterData: true });
        yield put(showToast(yield call(translateSaga, response.data.message)));
      } else {
        const { token, profile } = response.data;
        if (getConfig().loyaltyAccessUserIds) {
          if (getConfig().loyaltyAccessUserIds.includes(profile?.id) && profile?.id) {
            let config = getConfig()
            if (!config.flags.hasLoyalty) {
              config.flags.hasLoyalty = true
              updateConfig(config)
              const navConfig = yield call(initRouter, { front_end_app_config: config });
              yield put({ type: SET_NAVCONFIG, data: navConfig });
            }
          }
        }
        if (getConfig().giftVouchersAccessUserIds) {
          if (getConfig().giftVouchersAccessUserIds.includes(profile?.id) && profile?.id) {
            let config = getConfig()
            if (!config.flags.hasGiftVouchers || !config.flags.hasGiftCards || config.flags.removeGiftCardsFromBasket || !config.flags.hasApplyGiftCardCodeOnCheckout) {
              config.giftVouchersConfiguredFlags = { hasGiftVouchers: config.flags.hasGiftVouchers, hasGiftCards: config.flags.hasGiftCards, removeGiftCardsFromBasket: config.flags.removeGiftCardsFromBasket, hasApplyGiftCardCodeOnCheckout: config.flags.hasApplyGiftCardCodeOnCheckout }
              config.flags.hasGiftVouchers = true
              config.flags.hasGiftCards = true
              config.flags.removeGiftCardsFromBasket = false
              config.flags.hasApplyGiftCardCodeOnCheckout = true
              updateConfig(config)
              const navConfig = yield call(initRouter, { front_end_app_config: config });
              yield put({ type: SET_NAVCONFIG, data: navConfig });
            }
          }
        }
        yield call(asyncStorage.setItem, 'token', token);
        yield call(asyncStorage.setItem, 'profile', JSON.stringify(profile));

        yield put({ type: SET_PROFILE_PROP, key: 'auth', value: { loggedIn: true, token } });
        yield put({ type: SET_PROFILE_PROP, key: 'profile', value: profile });

        yield call(saveFcmToken);
        Basket.setLang(profile);
        if (store.orders.storedDeliveryAddress) {
          let found = !!profile.address_list.find(
            (al) =>
              al.addressLine1 + al.place + al.postalCode ===
              store.orders.storedDeliveryAddress.addressLine1 +
              store.orders.storedDeliveryAddress.place +
              store.orders.storedDeliveryAddress.postalCode,
          );
          if (type === 'Delivery' && store.orders.storedDeliveryAddress && !found) {
            yield put({
              type: ADD_DELIVERY_ADDRESS,
              deliveryAddress: store.orders.storedDeliveryAddress,
              flag: true,
            });
            yield put(storeDeliveryAddress(null));
          }
        }
        if (store.orders.storedPickUpPoint) {
          let found = !!profile.pickup_points_list.find(
            (pp) => pp.code === store.orders.storedPickUpPoint.pickUpPoint,
          );
          if (type === 'Outpost Drop-Off' && store.orders.deliveryAddress && !found) {
            yield put({
              type: ADD_PICKUP_POINT,
              pickUpPoint: store.orders.storedPickUpPoint,
              flag: true,
            });
            yield put(storePickUpPoint(null));
          }
        }
        const { navConfig } = yield select((state) => state.common);
        if (!fromBillPay && !createOrder) {
          forwardTo(referrer || getDefaultRoute(navConfig).path, { paymentType, fromLoyaltyPage, ...referrerState });
        }
        if (createOrder) {
          Basket.createOrder()
        }
      }
    });
    if (!tryRegister) {
      yield call(postLogingFlow, promo_code);
    }
  }
};

export const restoreAuthSaga = function* () {
  const token = yield call(asyncStorage.getItem, 'token');
  const profile = yield call(asyncStorage.getItem, 'profile');

  if (isDefined(token) && isDefined(profile)) {
    yield put({ type: SET_PROFILE_PROP, key: 'auth', value: { loggedIn: true, token } });
    yield put({ type: SET_PROFILE_PROP, key: 'profile', value: JSON.parse(profile) });
    yield call(api.createAxiosInstance, token);
    yield call(saveFcmToken);
    yield call(postLogingFlow);
  } else {
    yield call(api.createAxiosInstance);
  }
  return;
};

export const restoreAuthFlow = function* () {
  while (true) {
    yield take(RESTORE_AUTH);
    yield call(restoreAuthSaga);
  }
};

const periodicalSaga = function* () {
  while (true) {
    try {
      if (isDefined(Basket.collection_time)) {
        const collection_time = moment.unix(Basket.collection_time);
        const store = yield select();
        const hasBaksetResetModalOpen = store.common.hasBaksetResetModalOpen;
        const current_time = moment().tz(getConfig().timezone);
        if (moment().tz(getConfig().timezone).isAfter(moment.unix(Basket.collection_time).add(24, 'hours'))) {
          Basket.reset()
        }
        else if (isDefined(getConfig().general.basketTime)) {
          const c_t = collection_time.add(getConfig().general.basketTime, 'minutes');
          const cutoff_time = moment.unix(Basket.cutoffTime);
          if ((Basket.order_type === 'pick-up-point' || Basket.order_type === 'charter-delivery' || Basket.order_type === 'delivery') && cutoff_time.isBefore(current_time) && !Basket.is_asap) {
            if (Basket.getAllItems().length == 0) {
              Basket.reset()
            } else {
              yield put({
                type: SET_COMMON_MODAL,
                modal: 'removeBasketItemsModalOpen',
                value: {
                  showAlert: true,
                },
              });
            }
          } else if ((Basket.order_type === 'table' || Basket.order_type === 'pick-up-at-counter') && current_time.isAfter(cutoff_time.add(1, 'hours'))) {
            if (Basket.getAllItems().length == 0) {
              Basket.reset()
            } else {
              yield put({
                type: SET_COMMON_MODAL,
                modal: 'removeBasketItemsModalOpen',
                value: {
                  showAlert: true,
                  message: 'Placing your order took more than an hour, due to a possible menu and restaurant changes, please start the order again.',
                },
              });
            }
          }


        }
        // TO UPDATE
        // if (isDefined(getConfig().general.basketTime) && Basket.getOrderSartingTime()) {
        //   const order_time = moment.unix(Basket.getOrderSartingTime())
        //   const c_t = order_time.clone().add(getConfig().general.basketTime, 'minutes').tz(getConfig().timezone);
        //   if ((Basket.order_type === 'pick-up-point' || Basket.order_type === 'charter-delivery' || Basket.order_type === 'delivery' || Basket.order_type === 'table' || Basket.order_type === 'pick-up-at-counter') && current_time.isAfter(c_t)) {
        //     yield put({
        //       type: SET_COMMON_MODAL,
        //       modal: 'removeBasketItemsModalOpen',
        //       value: {
        //         showAlert: true,
        //       },
        //     });
        //   }

        // }
        if (moment(collection_time).isAfter(current_time)) {
          Basket._isCollectionTimeStillValid(true);
        }
      }
      yield delay(getConfig().general.periodForSaga * 1000);
    } catch (e) {
      yield call(errorHandlerSaga, e);
    }
  }
};


const startPeriodicalSaga = function* () {
  // periodicalSaga is now at the same level as root saga
  const timer = yield spawn(periodicalSaga);
  const store = yield select();
  if (isDefined(store.profile.timer)) {
    yield cancel(store.profile.timer);
  }
  yield put({ type: SET_PROFILE_PROP, key: 'timer', value: timer });
};

const stopPeriodicalSaga = function* () {
  const store = yield select();
  if (isDefined(store.profile.timer)) {
    yield cancel(store.profile.timer);
  }
  yield put({ type: SET_PROFILE_PROP, key: 'timer', value: null });
};

const postLogingFlow = function* (promo_code) {
  if (getConfig().flags.hasOrdering || getConfig().flags.hasGiftVouchers || getConfig().flags.hasMembership) {
    if (Capacitor.getPlatform() === 'web' || getConfig()?.squarePayment?.enabled) {
      yield put(getPaymentCards());
    }
    yield put({ type: GET_ORDER_HISTORY, loading: false });
  }
  yield put({ type: GET_VOUCHERS });


  yield call(startPeriodicalSaga);
  yield call(showValidationPopUp);
  yield call(applayLocale);
  if (promo_code) {
    const result = yield call(api.sendCode, { code: promo_code });
    if (!result.error && !result.Error) {
      yield put({
        type: SET_COMMON_PROP,
        key: 'voucherAddedModalOpen',
        value: true,
      });
    }
  }
  try {
    yield spawn(firebaseDatabase);
  } catch (e) {
    yield call(errorHandlerSaga, e);
  }
};

/* Register saga */
export const registerFlow = function* () {
  //const store = yield select()
  while (true) {
    const registerRequest = yield take(REGISTER_REQUEST);

    yield call(loading, function* () {
      const profile = yield select((state) => state.profile);
      const { registerFormData, sysLocale } = profile;
      const myLocation = yield select((state) => state.common.myLocation);
      const locale = getConfig().localization.defaultLocale;
      const socialAuth = registerRequest.data?.socialAuth || {};
      const data = {
        ...registerFormData,
        sysLocale,
        myLocation:
          myLocation.latitude !== null && myLocation.longitude !== null ? myLocation : undefined,
        locale,
        socialAuth,
      };
      const response = yield call(authorize, { ...data, isRegistering: true });
      // yield put({ type: CLEAR_REGISTER_FORM });
      //auto login after register
      let referrer = yield select((state) => state.profile.referrer);
      if (response.data && response.data.referrer) {
        referrer = response.data.referrer;
      }
      if (registerRequest.data?.referrerState) {
        referrer = registerRequest.data.referrer;
      }
      //add refresh_token so user can auto login with apple
      socialAuth.refresh_token = response.data ? response.data.refresh_token : null;
      const { email, password } = data;
      yield put({
        type: LOGIN_REQUEST,
        username: email,
        password: password,
        referrer,
        referrerState: registerRequest.data?.referrerState,
        fromBillPay: registerRequest?.fromBillPay,
        socialAuth,
        promo_code: registerFormData?.promo_code ?? undefined,
        paymentType: registerRequest.data?.paymentType ?? undefined,
        fromLoyaltyPage: registerRequest.data?.fromLoyaltyPage ?? undefined,
        createOrder: registerRequest.data?.createOrder ?? undefined,
      });
    });
  }
};

/* Log out saga */
export const logoutFlow = function* () {
  while (true) {
    const action = yield take(LOGOUT);
    yield call(asyncStorage.removeItem, 'token');
    yield call(asyncStorage.removeItem, 'profile');
    yield put({ type: SET_PROFILE_PROP, key: 'auth', value: {} });
    yield put({ type: SET_PROFILE_PROP, key: 'profile', value: {} });
    yield put({ type: SET_PROFILE_PROP, key: 'vouchers', value: [] });
    yield put({ type: SET_ORDERS_PROP, key: 'cards', value: [] });
    yield put({ type: SET_ORDERS_PROP, key: 'orderHistory', value: [] });
    yield put({ type: SET_PROFILE_PROP, key: 'giftCards', value: [] });
    yield put({ type: CLEAR_REGISTER_FORM });
    yield put({ type: CLEAR_GUEST_FORM });


    yield put({ type: SET_PROTECTED_REFERRER, path: null });
    Basket.reset();
    //stop periodical profile fetching
    yield call(stopPeriodicalSaga);
    if (getConfig().loyaltyAccessUserIds) {
      let config = getConfig()
      config.flags.hasLoyalty = false
      updateConfig(config)
    }
    if (getConfig().giftVouchersConfiguredFlags) {
      let config = getConfig()
      config.flags.hasGiftVouchers = config.giftVouchersConfiguredFlags.hasGiftVouchers
      config.flags.hasGiftCards = config.giftVouchersConfiguredFlags.hasGiftCards
      config.flags.removeGiftCardsFromBasket = config.giftVouchersConfiguredFlags.removeGiftCardsFromBasket
      config.flags.hasApplyGiftCardCodeOnCheckout = config.giftVouchersConfiguredFlags.hasApplyGiftCardCodeOnCheckout
      delete config.giftVouchersConfiguredFlags
      updateConfig(config)
    }
    const { navConfig } = yield select((state) => state.common);
    forwardTo(getDefaultRoute(navConfig).path);

    if (isDefined(action.cb) && action.cb) {
      yield call(action.cb);
    }
  }
};

/* get Profile saga */
export const getProfileFlow = function* () {
  while (true) {
    const action = yield take(GET_PROFILE);
    const saga = function* () {
      const token = yield call(asyncStorage.getItem, 'token');
      if (token && !isAuthorizationTokenSet()) {
        yield call(api.createAxiosInstance, token);
      }
      const response = yield call(api.getProfile);
      const profile = response.data.profile;
      if (getConfig().loyaltyAccessUserIds) {
        if (getConfig().loyaltyAccessUserIds.includes(profile?.id) && profile?.id) {
          let config = getConfig()
          if (!config.flags.hasLoyalty) {
            config.flags.hasLoyalty = true
            updateConfig(config)
            const navConfig = yield call(initRouter, { front_end_app_config: config });
            yield put({ type: SET_NAVCONFIG, data: navConfig });
          }
        }
      }
      if (getConfig().giftVouchersAccessUserIds) {
        if (getConfig().giftVouchersAccessUserIds.includes(profile?.id) && profile?.id) {
          let config = getConfig()
          if (!config.flags.hasGiftVouchers || !config.flags.hasGiftCards || config.flags.removeGiftCardsFromBasket || !config.flags.hasApplyGiftCardCodeOnCheckout) {
            config.giftVouchersConfiguredFlags = { hasGiftVouchers: config.flags.hasGiftVouchers, hasGiftCards: config.flags.hasGiftCards, removeGiftCardsFromBasket: config.flags.removeGiftCardsFromBasket, hasApplyGiftCardCodeOnCheckout: config.flags.hasApplyGiftCardCodeOnCheckout }
            config.flags.hasGiftVouchers = true
            config.flags.hasGiftCards = true
            config.flags.removeGiftCardsFromBasket = false
            config.flags.hasApplyGiftCardCodeOnCheckout = true
            updateConfig(config)
            const navConfig = yield call(initRouter, { front_end_app_config: config });
            yield put({ type: SET_NAVCONFIG, data: navConfig });
          }
        }
      }
      yield put({ type: SET_PROFILE_PROP, key: 'profile', value: profile });
      yield call(asyncStorage.setItem, 'profile', JSON.stringify(profile));
      yield call(applayLocale);
    };
    if (action.skipLoading) {
      yield call(saga);
    } else {
      yield call(saga);
    }
  }
};

/* update Profile saga */
export const updateProfileFlow = function* () {
  while (true) {
    const action = yield take(UPDATE_PROFILE);
    yield call(loading, function* () {
      const response = yield call(api.updateProfile, action.data);
      const profile = response.data.profile;
      yield put({ type: SET_PROFILE_PROP, key: 'profile', value: profile, merge: true });
      yield call(asyncStorage.setItem, 'profile', JSON.stringify(profile));
      yield call(applayLocale);
      if (!isDefined(action.skipAlert) || !action.skipAlert) {
        yield put({ type: SET_MODAL, modal: 'isProfileModalOpen', value: true });
      }
    });
  }
};

/* reset Password saga */
export const resetPasswordFlow = function* () {
  while (true) {
    const action = yield take(RESET_PASSWORD);
    yield call(api.resetPassword, action.email);
    yield put({ type: SET_MODAL, modal: 'isResetPasswordModalOpen', value: true });
  }
};

/* validte Email saga */
export const validateEmailFlow = function* () {
  while (true) {
    const action = yield take(VALIDATE_EMAIL);
    const validate_profile = action.validate_profile;
    yield put({ type: UPDATE_PROFILE, validate_profile, skipAlert: true });
    const result = yield call(api.validateEmail);
    yield put(showToast(yield call(translateSaga, result.data.data.success), 'success'));
  }
};

/* show validtion PopUp Flow saga */
export const showValidationPopUp = function* () {
  const profile = yield select((state) => state.profile.profile);
  const valid = validateProfileData(profile).isValid;
  if (
    getConfig().appType.hasEmailValidationEnabled &&
    valid &&
    isDefined(profile.is_verification_pop_up_shown) &&
    !profile.is_verification_pop_up_shown
  ) {
    yield put({ type: SET_COMMON_MODAL, modal: 'isValidationModalOpen', value: true });
  }
};

export const sendReferFlow = function* () {
  while (true) {
    const action = yield take(SEND_REFER);
    yield call(loading, function* () {
      const result = yield call(api.sendRefer, action.data);
      if (!result.error) {
        yield put({
          type: SET_COMMON_PROP,
          key: 'referAFriendModalOpeed',
          value: true,
        });
      }
    });
  }
};

export const sendVoucherCodeFlow = function* () {
  while (true) {
    const action = yield take(SEND_VOUCHER_CODE);
    yield call(loading, function* () {
      const result = yield call(api.sendCode, action.data);
      if (action.autoApplyVoucher) {
        const response = yield call(api.checkDiscount, Basket.parseBasketForCheckVouchers());
        const applicableVouchers = response.data.data || [];
        const appliedVoucher = result.voucher;
        const applicableVoucher = applicableVouchers.find((appliableVoucher) => appliableVoucher.id === appliedVoucher.id);
        if (applicableVoucher && Basket.canVoucherBeApplied(appliedVoucher, applicableVoucher)) {
          Basket.addVoucher(appliedVoucher, applicableVoucher);
        }
      }
      if (!result.is_gift && !result.is_event) {
        yield put({ type: GET_VOUCHERS });
        if (action.orderCreated) {
          yield put({
            type: CHECKOUT_DISCOUNT_VOUCHERS,
            data: Basket.parseBasketForCheckVouchers(),
          });
        }

        if (!result.error && !result.Error) {
          yield put({
            type: SET_COMMON_PROP,
            key: 'voucherCodeAlertVisible',
            value: false,
          });
          yield put({
            type: SET_COMMON_PROP,
            key: 'voucherAddedModalOpen',
            value: true,
          });
        }
      } else {
        yield put({
          type: SET_COMMON_PROP,
          key: 'redeemGiftVoucherMessage',
          value: result.message,
        });
        yield put({
          type: SET_COMMON_MODAL,
          modal: 'isRedeemGiftVoucherModalOpen',
          value: true,
        });
      }
    });
  }
};

export const getVouchersFlow = function* () {
  while (true) {
    yield take(GET_VOUCHERS);
    if (getConfig().vouchersType === 2) {
      yield call(loading, function* () {
        const { isReward } = getConfig().appType;
        // let rewardType = getConfig().rewardType
        let rewards = null;
        if (isReward) {
          let result = yield call(api.getRewards);
          rewards = result.map((data) => {
            return data.reward;
          });
        } else {
          rewards = yield call(api.getRewards);
        }
        rewards = rewards.sort((a, b) => {
          if (a.cost < b.cost) {
            return -1;
          }
          if (a.cost > b.cost) {
            return 1;
          }
          return 0;
        });
        yield put({ type: SET_PROFILE_PROP, key: 'vouchers', value: rewards });
      });
    } else if (getConfig().vouchersType === 1) {
      // if (getConfig().appType.hasCampaignManager) {
      const response = yield call(api.getVouchers);
      if (!response.error) {
        yield put({ type: SET_PROFILE_PROP, key: 'vouchers', value: response.data });
      }
      // }
    } else {
      const { isReward } = getConfig().appType;
      // let rewardType = getConfig().rewardType
      let rewards = null;
      if (isReward) {
        let result = yield call(api.getRewards);
        rewards = result.map((data) => {
          return data.reward;
        });
      } else {
        rewards = yield call(api.getRewards);
      }
      rewards = rewards.sort((a, b) => {
        if (a.cost < b.cost) {
          return -1;
        }
        if (a.cost > b.cost) {
          return 1;
        }
        return 0;
      });
      const response = yield call(api.getVouchers);
      response.data.map((data) => {
        data['type'] = 1;
        rewards.push(data);
        return true;
      });
      yield put({ type: SET_PROFILE_PROP, key: 'vouchers', value: rewards });
    }
  }
};

export const checkDiscountFlow = function* () {
  while (true) {
    const action = yield take(CHECKOUT_DISCOUNT_VOUCHERS);
    if (getConfig().appType.hasCampaignManager) {
      const response = yield call(api.checkDiscount, action.data);
      if (!response.error) {
        yield put({
          type: SET_PROFILE_PROP,
          key: 'applicableVouchers',
          value: response.data.data,
        });
      }
    }
  }
};
export const checkMultiBasketDiscountFlow = function* () {
  while (true) {
    const action = yield take(CHECKOUT_MULTI_BASKET_DISCOUNT);
    if (getConfig().flags.hasCampaignManager) {
      const response = yield call(api.checkMultiBasketDiscount, action.data);
      if (!response.error) {
        yield put({
          type: SET_PROFILE_PROP,
          key: 'applicableVouchers',
          value: response.data.data,
        });
      }
    }
  }
};
export const checkDiscountWithTaxesFlow = function* () {
  while (true) {
    const action = yield take(CHECKOUT_TAX_DISCOUNT_VOUCHERS);
    if (getConfig().appType.hasCampaignManager) {
      const response = yield call(api.checkDiscountWithTaxes, action.data);
      if (!response.error) {
        yield put({
          type: SET_PROFILE_PROP,
          key: 'applicableVouchers',
          value: response.data.data,
        });
      }
    }
  }
};
export const checkMultiBasketDiscountWithTaxesFlow = function* () {
  while (true) {
    const action = yield take(CHECKOUT_TAX_MULTI_BASKET_DISCOUNT);
    if (getConfig().flags.hasCampaignManager) {
      const response = yield call(api.checkMultiBasketDiscountWithTaxes, action.data);
      if (!response.error) {
        yield put({
          type: SET_PROFILE_PROP,
          key: 'applicableVouchers',
          value: response.data.data,
        });
      }
    }
  }
};
export const checkVoucherDiscountFlow = function* () {
  while (true) {
    const action = yield take(CHECK_VOUCHER_DISCOUNT);
    if (getConfig().flags.hasCampaignManager) {
      yield call(loading, function* () {
        const response = yield call(api.voucherDiscount, action.data);
        if (!response.data.error) {
          yield put({
            type: SET_PROFILE_PROP,
            key: 'applicableVouchers',
            value: [response.data.data],
          });
          Basket.addVoucher(action.data.selectedVoucher, response.data.data);
          if (response?.data?.data?.taxes?.length > 0) {
            let taxes = response.data.data.taxes.map((tax) => {
              return {
                total_tax: parseFloat((tax?.applied_money?.amount / 100).toFixed(2)),
                tax_lines: [{
                  tax_name: tax.name,
                  tax_amount: parseFloat((tax?.applied_money?.amount / 100).toFixed(2))
                }]
              }
            });
            Basket.setTaxBreakdown(taxes);
            yield put({ type: SET_COMMON_PROP, key: 'taxCalculated', value: true });
          }
          forwardTo('/order-summary')

        } else {
          yield put({ type: SET_COMMON_PROP, key: 'voucherErrorModalOpen', value: true })

        }
      });
    }
  }
};


export const removeVoucherFlow = function* () {
  while (true) {
    const { voucher } = yield take(REMOVE_VOUCHER);
    yield put({ type: SET_MODAL, modal: 'isRemoveVoucherModalOpen', value: false });
    yield call(loading, function* () {
      if (voucher.source == 'atreemo') {
        let response = yield call(api.releaseVoucher, { discount_id: voucher.voucher_code, id: voucher.id });
        if (response.error) {
          yield put(showToast(yield call(translateSaga, response.error), 'danger'));
        } else {
          yield put({ type: SET_COMMON_PROP, key: 'voucherRemovedModalOpen', value: true });
          Basket.clearAllDiscounts(false, true);
        }
      } else {
        yield put({ type: SET_COMMON_PROP, key: 'voucherRemovedModalOpen', value: true });
        Basket.clearAllDiscounts(false, true);
      }

    });
  }
};

export const removeProfileFlow = function* () {
  while (true) {
    const action = yield take(REMOVE_PROFILE);
    yield call(loading, function* () {
      yield put({ type: LOGOUT });
      let response = yield call(api.removeProfile, { token: action.token });
      response = response.data;
      if (response.error) {
        yield put(showToast(yield call(translateSaga, response.error), 'danger'));
      } else if (response.message) {
        yield put(showToast(yield call(translateSaga, response.message), 'success'));
      }
    });
  }
};

export const updateProfileImageFlow = function* () {
  while (true) {
    const { image } = yield take(UPDATE_PROFILE_IMAGE);
    const data = new FormData();
    data.append('profile_image', image, image.name);
    const response = yield call(api.updateProfileImage, data);
    if (response?.data?.profile) {
      const profile = response.data.profile;
      yield put({ type: SET_PROFILE_PROP, key: 'profile', value: profile });
      yield call(asyncStorage.setItem, 'profile', JSON.stringify(profile));
      yield call(applayLocale);
    }
    if (response.error) {
      yield put(showToast(yield call(translateSaga, response.error), 'danger'));
    } else if (response.message) {
      yield put(showToast(yield call(translateSaga, response.message), 'success'));
    }
  }
};
export const buyRewardFlow = function* () {
  while (true) {
    const { data } = yield take(BUY_REWARD);
    yield call(loading, function* () {
      let response = null
      if (data.atreemo) {
        response = yield call(api.butAtreemoReward, { offer_id: data.rewardId });

      } else {
        response = yield call(api.buyReward, data.rewardId);

      }
      if (response.error) {
        yield put(showToast(yield call(translateSaga, response.error), 'danger'));
      } else {
        yield put({
          type: SET_COMMON_PROP,
          key: 'voucherAddedModalOpen',
          value: true,
        });
      }
    });
  }
};
export const getGiftCardsFlow = function* () {
  while (true) {
    yield take(GET_GIFT_CARDS);
    const response = yield call(api.getGiftCards);
    if (!response.error) {
      yield put({ type: SET_PROFILE_PROP, key: 'giftCards', value: response.data });
    }
  }
};

export const sendGiftCardCodeFlow = function* () {
  while (true) {
    const action = yield take(SEND_GIFT_CARD_CODE);
    yield call(loading, function* () {
      const result = yield call(api.sendGiftVoucherCode, action.data);
      if (!result.error && !result.Error) {
        Basket.setCheckoutGiftCards([result.data])
        yield put({
          type: SET_COMMON_PROP,
          key: 'giftCardCodeAlertVisible',
          value: false,
        });
        yield put({
          type: SET_COMMON_PROP,
          key: 'giftCardAddedModalOpen',
          value: true,
        });
      }

    });
  }
};

export const getNotificationsFlow = function* () {
  while (true) {
    yield take(GET_NOTIFICATIONS);
    yield call(loading, function* () {
      let response = yield call(api.getNotifications);
      if (response.error) {
        yield put(showToast(yield call(translateSaga, response.error), 'danger'));
      } else {
        yield put({ type: SET_NOTIFICATIONS, value: response });

      }
    });
  }
};

export const readNotificationsFlow = function* () {
  while (true) {
    const { data } = yield take(READ_NOTIFICATION);
    yield call(loading, function* () {
      let response = yield call(api.readNotifications, data);
      yield put({ type: SET_NOTIFICATIONS, value: response.data });
      if (response.error) {
        yield put(showToast(yield call(translateSaga, response.error), 'danger'));
      }
    });
  }
};
export const deleteNotificationsFlow = function* () {
  while (true) {
    const { data } = yield take(DELETE_NOTIFICATION);
    yield call(loading, function* () {
      let response = yield call(api.deleteNotification, data);
      if (response.error) {
        yield put(showToast(yield call(translateSaga, response.error), 'danger'));
      } else {
        yield put({ type: GET_NOTIFICATIONS })

      }
    });
  }
};
export const removeGiftCardFlow = function* () {
  while (true) {
    const { data } = yield take(REMOVE_GIFT_CARD);
    yield call(loading, function* () {
      try {
        const response = yield call(api.removeGiftCard, data);
        if (response.error) {
          yield put(showToast(yield call(translateSaga, response.error.message || response.error), 'danger'));
        } else {
          yield put(showToast(yield call(translateSaga, 'Gift card deleted'), 'success'));
          forwardTo('/gift-cards');
        }
      } catch (error) {
        const message = error.response?.data?.error?.message || error.response?.data?.error || 'An error occurred. Please try again';
        yield put(showToast(yield call(translateSaga, message), 'danger'));
      }
    });
  }
};
